<template>
  <v-window
    class="patient-snapshot-slider"
    v-model="currentSnapshot"
    show-arrows
  >
    <v-window-item
      v-for="snapshot in snapshots"
      :key="`card-${snapshot.id}`"
    >
      <v-card
        class="patient-snapshot-slider__card d-flex align-center justify-center ma-2"
        elevation="2"
      >
        <div class="patient-snapshot-slider__img-wrapper">
          <img alt="Снимок пациента" v-bind:src="snapshot.url" />
        </div>
      </v-card>
    </v-window-item>
    <button
      class="patient-snapshot-slider__cross"
      type="button"
      title="Закрыть окно"
      v-on:click="onClickCross"
    />
  </v-window>
</template>

<script>
export default {
  /**
   * @description Слайдер снимков пациентов.
   */
  name: 'PatientSnapshotSlider',
  data() {
    return {
      /**
       * @description Выбранный снимок.
       * @type {Number}
       */
      currentSnapshot: this.value,
    };
  },
  methods: {
    /**
     * @description Обработать событие нажатия на крестик.
     * @returns {void}
     */
    onClickCross() {
      this.$emit('close');
    },
  },
  props: {
    /**
     * @description Снимки.
     * @type Array
     */
    snapshots: {
      required: true,
      type: Array,
    },
    /**
     * @description Модель.
     * @type Number
     */
    value: {
      required: false,
      type: Number,
      default: () => 0,
    },
  },
  watch: {
    value(newValue) {
      this.currentSnapshot = newValue;
    },
  },
};
</script>

<style scoped lang="scss">
.patient-snapshot-slider {
  &__card {
    height: 85svh;
  }
  &__img-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80%;
    max-width: 700px;
    height: 100%;
    max-height: 75svh;
    img {
      max-width: 700px;
      width: 100%;
      height: auto;
      max-height: 75svh;
      object-fit: contain;
    }
  }
  &__cross {
    position: absolute;
    right: 25px;
    top: 25px;
    cursor: pointer;
    background-image: url("@/assets/img/exit-black.svg");
    background-repeat: no-repeat;
    background-size: contain;
    width: 17px;
    height: 17px;
  }
}

@media screen and (max-width: 768px) {
  .patient-snapshot-slider {
    &__card {
      img {
        max-width: 650px;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .patient-snapshot-slider {
    &__card {
      height: 80svh
    }
  }
}
</style>
